import React from 'react';
import PropTypes from 'prop-types';
import bemCnFast from '@webteam/bem-cn-fast';
import localNames from './unselect-option-hint.module.pcss.js';

var bemCn = bemCnFast('wt-unselect-option-hint', localNames);

var UnselectOptionHint = function UnselectOptionHint(_ref) {
  var text = _ref.text,
      size = _ref.size,
      theme = _ref.theme;
  return React.createElement("span", {
    className: bemCn({
      size: size,
      theme: theme
    })
  }, text);
};

UnselectOptionHint.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(['m', 's', 'xs']),
  theme: PropTypes.oneOf(['light', 'dark'])
};

export { UnselectOptionHint as default };
